import { Align } from './common';

export enum HomeGroupKey {
  HOME_EXPLORER = 'HomeExplorer',
  HOME_TILES = 'HomeTile',
}

export enum FormCard {
  PROMOTION = 'PROMOTION',
  TEMPLATE = 'TEMPLATE',
  JUST_IN = 'JUST_IN',
  INSIGHTS = 'INSIGHTS',
  HANDICAP = 'HANDICAP',
  SCORE = 'SCORE',
  TARGET = 'TARGET',
}

export enum HomeType {
  PROMOTION = 'PROMOTION',
  INSIGHT_OVERVIEW = 'INSIGHT_OVERVIEW',
  AVERAGE_SCORE = 'AVERAGE_SCORE',
  HANDICAP_INDEX = 'HANDICAP_INDEX',
  TARGET_SCORE = 'TARGET_SCORE',
}

export enum HomeTypeExplorer {
  FEATURED_STORY = 'FEATURED_STORY',
  FEATURED_VIDEO = 'FEATURED_VIDEO',
  MEMBER_ONLY_EXCLUSIVE = 'MEMBER_ONLY_EXCLUSIVE',
  DRILL_OF_THE_WEEK = 'DRILL_OF_THE_WEEK',
  DRILL_OF_THE_MONTH = 'DRILL_OF_THE_MONTH',
  ON_TOUR = 'ON_TOUR',
}

export enum HomeWidgetStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CLOSED = 'CLOSED',
}

export enum CATEGORY {
  CMS = 'CMS',
  ECOM_PRODUCT = 'ECOM_PRODUCT',
  APP_DEEP_LINK = 'APP_DEEP_LINK',
  WEB_LINK = 'WEB_LINK',
  NO_CTA = 'NO_CTA',
}

export const TEXT_CATEGORY = {
  [CATEGORY.CMS]: 'CMS',
  [CATEGORY.ECOM_PRODUCT]: 'Member Shop',
  [CATEGORY.APP_DEEP_LINK]: 'App Deep Link',
  [CATEGORY.WEB_LINK]: 'Link',
  [CATEGORY.NO_CTA]: 'No CTA',
};

export enum FEATURE {
  COACHING_PLANS = 'COACHING_PLANS',
  SHOP_DROP = 'SHOP_DROP',
  DRILLS_FOR_YOU = 'DRILLS_FOR_YOU',
  VIEW_SCORES = 'VIEW_SCORES',
  POST_SCORES = 'POST_SCORES',
  GAME_PROFILE = 'GAME_PROFILE',
  CART = 'CART',
  FITTINGS = 'FITTINGS',
  MY_BAG = 'MY_BAG',
  SUBSCRIPTION = 'SUBSCRIPTION',
  TOUR_TRASH = 'TOUR_TRASH',
  TTB = 'TTB',
  INSIGHTS = 'INSIGHTS',
  COMPARE_CLUB = 'COMPARE_CLUB',
  STATS = 'STATS',
  MY_TAYLORMADE_ON_COURSE = 'MY_TAYLORMADE_ON_COURSE',
  CLUB_RECOMMENDER = 'CLUB RECOMMENDATION',
  PERK = 'PERK',
  REFERRAL = 'REFERRAL',
  PROFILE = 'PROFILE',
  PLAY = 'PLAY',
  SHOP = 'SHOP',
  ARTICLES = 'ARTICLES',
  REWARDS = 'REWARDS',
}

export interface HomeWidgetsForm {
  name?: string;
  heading?: string;
  description?: string;
  title?: string;
  backgroundColor?: string;
  backgroundImage?: string;
  ctaText?: string;
  ctaLink?: string;
  category?: string;
  textColor?: string;
  colorOpacity?: number;
  buttonAlign?: Align;
  textAlign?: Align;
  countries?: any;
}

export interface HomeWidgetsDefaultForm {
  status?: HomeWidgetStatus;
  groupKey?: HomeGroupKey;
  type: string;
  contentType?: string;
  contentId?: any;
  productId?: string;
  contentFormat?: string;
  ctaText?: string;
  ctaLink?: string;
  sortOrder?: number;
  extraData?: any;
  show?: boolean;
  countries?: any;
}

export interface HomeWidgetsSubmitForm extends HomeWidgetsForm, HomeWidgetsDefaultForm {}
